/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Page_Online_TitleInputs */

const en_vc_page_online_title = /** @type {(inputs: Vc_Page_Online_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft Online: Free Vector Editor in Your Browser, No Install`)
};

const zh_vc_page_online_title = /** @type {(inputs: Vc_Page_Online_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 在线版：免安装的免费浏览器矢量编辑器`)
};

/**
* | output |
* | --- |
* | "VectorCraft Online: Free Vector Editor in Your Browser, No Install" |
*
* @param {Vc_Page_Online_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_page_online_title = /** @type {((inputs?: Vc_Page_Online_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Page_Online_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_page_online_title(inputs)
	return zh_vc_page_online_title(inputs)
});
export { vc_page_online_title as "vc.page.online.title" }